// Lessons created in bulk arrive named "Lesson 1", "Lesson 2", … — a position
// in a list, not a title anyone chose.
//
// Two screens act on this and they have to agree, which is why the test lives
// here rather than in either of them:
//
//   - the Lesson Generator opens the name field empty for one of these, so the
//     teacher writes a real title instead of saving the placeholder;
//   - the lesson card refuses inline renaming of one, because the name belongs
//     to the lesson that has not been created yet.
//
// Matching is deliberately tight: the whole value must be the word "Lesson"
// and a number, so "Lesson 3: Neurons" and "Lesson Planning" are left alone.
const GENERATED_LESSON_NAME = /^\s*lesson[\s._-]*0*\d+\s*$/i;

export const isGeneratedLessonName = (name) =>
  typeof name === "string" && GENERATED_LESSON_NAME.test(name);

export default isGeneratedLessonName;
